import api from "../services/api";

/**
 * GET a file from the API and save it in the browser. Uses the server's
 * Content-Disposition filename when available, otherwise `fallbackName`.
 */
export const downloadFile = async (
  url: string,
  params: Record<string, unknown>,
  fallbackName: string
) => {
  const res = await api.get(url, { params, responseType: "blob" });
  const fileName =
    /filename="([^"]+)"/.exec(res.headers["content-disposition"] || "")?.[1] || fallbackName;
  const href = URL.createObjectURL(res.data);
  const link = document.createElement("a");
  link.href = href;
  link.download = fileName;
  link.click();
  URL.revokeObjectURL(href);
};
